(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.tigCardSwatches) return;
    window.tigCardSwatches = true;

    const findImage = (swatch) => {
      const card = swatch.closest('product-card');
      if (!card) return null;
      const gallery = card.querySelector('[ref="cardGallery"]');
      if (!gallery) return null;
      return gallery.querySelector('slideshow-slide:not([aria-hidden="true"]) img') || gallery.querySelector('img');
    };

    const preview = (swatch) => {
      if (!swatch.dataset.tigSrc) return;
      const img = findImage(swatch);
      if (!img) return;
      if (img.dataset.tigOrigSrc === undefined) {
        img.dataset.tigOrigSrc = img.getAttribute('src') || '';
        img.dataset.tigOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', swatch.dataset.tigSrcset);
      img.setAttribute('src', swatch.dataset.tigSrc);
    };

    const reset = (swatch) => {
      const img = findImage(swatch);
      if (!img || img.dataset.tigOrigSrc === undefined) return;
      img.setAttribute('srcset', img.dataset.tigOrigSrcset);
      img.setAttribute('src', img.dataset.tigOrigSrc);
      delete img.dataset.tigOrigSrc;
      delete img.dataset.tigOrigSrcset;
    };

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const swatch = event.target.closest?.('.tig-card-colors__swatch');
      if (swatch) preview(swatch);
    });
    document.addEventListener('pointerout', (event) => {
      const swatch = event.target.closest?.('.tig-card-colors__swatch');
      if (swatch && !swatch.contains(event.relatedTarget)) reset(swatch);
    });
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest?.('.tig-card-colors__swatch');
      if (!swatch) return;
      event.stopPropagation();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
